import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
// import * as c from '../constants';

function ViewModalImage({ value }) {
  return (

    <Modal.Body>
      <div className="container h-100">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="mx-auto">
            <img src={value} alt="" />
          </div>
        </div>
      </div>
    </Modal.Body>
  );

}

ViewModalImage.defaultProps = {
  value: '',
};

ViewModalImage.propTypes = {
  value: PropTypes.string,
};
const enhance = _.flowRight([
  withForm,
]);

export default enhance(ViewModalImage);